import { defineComponent as _defineComponent } from 'vue'
import { toRefs } from 'vue';

  //eslint-disable-next-line
  
export default /*#__PURE__*/_defineComponent({
  __name: 'BaseInputSkeleton',
  props: {
    inputActive: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: null
    },
    inputColor: {
      type: String,
      default: 'gray-100'
    },
    inputBorderColor: {
      type: String,
      default: 'border-transparent'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

  

  const { inputActive, inputColor } = toRefs(props);

const __returned__ = { props, inputActive, inputColor, toRefs }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})